export const heartModuleOverview = [
  {
    id: "anatomy",
    title: "Cardiac Anatomy: Part 1",
    description: "Pericardium, chambers, valves and fibrous skeleton",
    icon: "❤️",
    customImage: "module-heart-anatomy.png",
    gradient: "from-red-100 via-pink-50 to-rose-100 border-red-300",
  },
  {
    id: "anatomy2",
    title: "Cardiac Anatomy: Part 2",
    description: "Coronary arteries, cardiac veins and surface projections",
    icon: "❤️",
    customImage: "module-heart-anatomy.png",
    gradient: "from-red-100 via-pink-50 to-rose-100 border-red-300",
  },
  {
    id: "conduction",
    title: "Heart Conduction System",
    description: "SA node, AV node, bundle branches and escape rhythms",
    icon: "⚡",
    customImage: "module-heart-conduction1.png",
    gradient: "from-rose-100 via-red-50 to-pink-100 border-rose-300",
  },
  {
    id: "electrophysiology",
    title: "ECG & Electrophysiology",
    description: "Action potentials, ECG interpretation and antiarrhythmics",
    icon: "📈",
    customImage: "module-heart-conduction.png",
    gradient: "from-yellow-100 via-lime-50 to-green-100 border-yellow-300",
  },
  {
    id: "histology",
    title: "Cardiac Histology",
    description: "Cardiomyocytes, sarcomere, intercalated discs and histopathology",
    icon: "🔬",
    customImage: "module-heart-histology.png",
    gradient: "from-yellow-100 via-lime-50 to-green-100 border-yellow-300",
  },
  {
    id: "physiology",
    title: "Cardiac Physiology",
    description: "Cardiac cycle, Frank-Starling, preload, afterload and coronary flow",
    icon: "🫀",
    gradient: "from-red-100 via-pink-50 to-rose-100 border-red-300",
  },
  {
    id: "disease",
    title: "Cardiac Diseases: CAD & ACS",
    description: "Atherosclerosis, stable angina, NSTEMI, STEMI and MI complications",
    icon: "🩺",
    gradient: "from-rose-200 via-red-50 to-orange-100 border-red-400",
  },
  {
    id: "disease2",
    title: "Cardiac Diseases: Heart Failure & Cardiomyopathies",
    description: "HFrEF, HFpEF, DCM, HCM, ARVC, restrictive and Takotsubo",
    icon: "🩺",
    gradient: "from-rose-200 via-red-50 to-orange-100 border-red-400",
  },
  {
    id: "disease3",
    title: "Cardiac Diseases: Valvular & Endocarditis",
    description: "AS, AR, MS, MR, TR and infective endocarditis",
    icon: "🩺",
    gradient: "from-rose-200 via-red-50 to-orange-100 border-red-400",
  },
  {
    id: "disease4",
    title: "Cardiac Diseases: Arrhythmias",
    description: "AF, SVT, WPW, VT/VF, AV block and cardiac arrest",
    icon: "🩺",
    gradient: "from-rose-200 via-red-50 to-orange-100 border-red-400",
  },
  {
    id: "disease5",
    title: "Cardiac Diseases: Pericardial, Myocarditis & Congenital",
    description: "Pericarditis, tamponade, myocarditis, ASD, VSD, TOF and coarctation",
    icon: "🩺",
    gradient: "from-rose-200 via-red-50 to-orange-100 border-red-400",
  },
  {
    id: "pharmacology",
    title: "Cardiac Pharmacology: Part 1",
    description: "Beta-blockers, RAAS inhibitors, ARNI, MRA, SGLT2i, digoxin and lipid therapy",
    icon: "💊",
    gradient: "from-emerald-100 via-teal-50 to-cyan-100 border-teal-400",
  },
  {
    id: "pharmacology2",
    title: "Cardiac Pharmacology: Part 2",
    description: "CCBs, nitrates, anticoagulants, cardiac devices and vasoactive drugs",
    icon: "💊",
    gradient: "from-emerald-100 via-teal-50 to-cyan-100 border-teal-400",
  },
  {
    id: "surgery",
    title: "Cardiac Surgery: Part 1",
    description: "Cardiopulmonary bypass, CABG and valve surgery",
    icon: "🏥",
    gradient: "from-sky-100 via-blue-50 to-indigo-100 border-blue-400",
  },
  {
    id: "surgery2",
    title: "Cardiac Surgery: Part 2",
    description: "Aortic surgery, PCI, catheter ablation, structural interventions and post-op care",
    icon: "🏥",
    gradient: "from-sky-100 via-blue-50 to-indigo-100 border-blue-400",
  },
];
